// Get user profile from localStorage
export const getProfile = () => {
    try {
      const profile = localStorage.getItem('userProfile');
      return profile ? JSON.parse(profile) : null;
    } catch (error) {
      console.error('Error getting profile:', error);
      return null;
    }
  };
  
  // Save user profile to localStorage
  export const saveProfile = (profile) => {
    try {
      localStorage.setItem('userProfile', JSON.stringify(profile));
      return true;
    } catch (error) {
      console.error('Error saving profile:', error);
      return false;
    }
  };
  
  // Get greeting based on time of day
  export const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
  };
  
  // Get user's name from profile
  export const getUserName = () => {
    const profile = getProfile();
    return profile?.name || 'Admin';
  };
  
  // Get full greeting with name
  export const getFullGreeting = () => {
    const greeting = getGreeting();
    const name = getUserName();
    return `${greeting}, ${name}!`;
  };